const services = [
  {
    icon: 'ri-home-heart-line',
    title: 'Benefício Assistencial (BPC/LOAS)',
    description:
      'Para idosos e pessoas com deficiência de baixa renda que nunca contribuíram com o INSS. Analisamos seu perfil e acompanhamos todo o processo.',
  },
  {
    icon: 'ri-shield-user-line',
    title: 'Aposentadoria',
    description:
      'Orientação completa para você obter a aposentadoria mais vantajosa, com análise do histórico contributivo e toda a documentação necessária.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Auxílio-Doença',
    description:
      'Se você está temporariamente incapacitado para o trabalho, garantimos seu benefício com agilidade e precisão técnica.',
  },
  {
    icon: 'ri-parent-line',
    title: 'Salário-Maternidade',
    description:
      'Seja trabalhadora urbana, rural ou desempregada — atuamos para garantir esse direito do início ao fim.',
  },
  {
    icon: 'ri-first-aid-kit-line',
    title: 'Auxílio-Acidente',
    description:
      'Redução de capacidade por acidente de trabalho? Trabalhamos na busca do direito a compensação financeira no INSS com a fundamentação técnica sólida',
  },
  {
    icon: 'ri-plant-line',
    title: 'Aposentadoria Rural',
    description:
      'Experiência prática na comprovação de atividade rural, mesmo sem registro em carteira de trabalho.',
  },
];

export default function ServicesSection() {
  return (
    <section id="servicos" className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-6 h-px bg-brand-gold" />
              <span className="font-inter text-xs font-medium text-brand-gold uppercase tracking-[0.18em]">
                Áreas de Atuação
              </span>
            </div>
            <h2 className="font-cormorant text-4xl lg:text-5xl font-semibold text-brand-dark leading-tight">
              Como podemos
              <br />
              <span className="italic">ajudar você</span>
            </h2>
          </div>
          <p className="font-inter text-sm text-brand-muted leading-relaxed max-w-xs lg:max-w-sm lg:text-right font-semibold">
            Cada caso é único. Analisamos sua situação com atenção e atuamos com estratégia para garantir o melhor resultado.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-brand-border">
          {services.map((service, i) => (
            <div
              key={i}
              className="group bg-white hover:bg-brand-cream p-8 lg:p-10 flex flex-col gap-5 transition-colors duration-300 cursor-default"
            >
              {/* Icon */}
              <div className="w-11 h-11 flex items-center justify-center bg-brand-cream group-hover:bg-white rounded-md transition-colors duration-300">
                <i className={`${service.icon} text-brand-gold text-xl`} />
              </div>

              {/* Content */}
              <div>
                <h3 className="font-playfair text-lg font-semibold text-brand-dark mb-3 leading-snug">
                  {service.title}
                </h3>
                <p className="font-inter text-sm text-brand-muted leading-relaxed">
                  {service.description}
                </p>
              </div>

              {/* Hover link */}
              <div className="mt-auto pt-4">
                <a
                  href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap cursor-pointer inline-flex items-center gap-1.5 font-inter text-xs font-medium text-brand-gold opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  Consultar sobre este serviço
                  <i className="ri-arrow-right-line text-sm" />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 pt-8 border-t border-brand-border">
          <p className="font-inter text-sm text-brand-muted">
            Não encontrou seu caso? Entre em contato.
          </p>
          <a
            href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20ba5a] text-white font-inter font-medium text-sm px-6 py-3 rounded-md transition-all duration-200"
          >
            <i className="ri-whatsapp-line text-base" />
            Consultar pelo WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
